(function () {
  const root = document.querySelector("[data-invoice-payment]");
  if (!root) return;

  const form = root.querySelector("[data-invoice-form]");
  const payButton = root.querySelector("[data-pay-button]");
  const status = root.querySelector("[data-payment-status]");
  const successPanel = root.querySelector("[data-payment-success]");
  const cardMount = root.querySelector("[data-card-element]");
  const amountInput = form.querySelector('input[name="amount"]');
  const subtotalOutput = root.querySelector("[data-invoice-subtotal]");
  const feeOutput = root.querySelector("[data-invoice-fee]");
  const totalOutput = root.querySelector("[data-invoice-total]");
  const stripeKey = root.dataset.stripeKey || "";
  const paymentEndpoint = root.dataset.paymentEndpoint || "";
  const CARD_FEE_RATE = 0.03;

  function showStatus(message, type) {
    status.textContent = message;
    status.hidden = false;
    status.className = "invoice-status " + (type === "success" ? "is-success" : "is-error");
  }

  function showSuccess() {
    if (!successPanel) {
      showStatus("Payment received. A receipt will be sent to the email entered above.", "success");
      return;
    }
    if (successPanel) successPanel.hidden = false;
    status.hidden = true;
    Array.from(form.elements).forEach(function (element) {
      element.disabled = true;
    });
    if (cardMount) cardMount.hidden = true;
    if (payButton) payButton.hidden = true;
    form.classList.add("is-paid");
    successPanel.scrollIntoView({ behavior: "smooth", block: "center" });
  }

  function dollarsToCents(value) {
    const amount = Number.parseFloat(value);
    if (!Number.isFinite(amount) || amount <= 0) return 0;
    return Math.round(amount * 100);
  }

  function formatMoney(cents) {
    return new Intl.NumberFormat("en-US", {
      style: "currency",
      currency: "USD"
    }).format(cents / 100);
  }

  function calculateTotals(value) {
    const subtotal = dollarsToCents(value);
    const fee = subtotal > 0 ? Math.round(subtotal * CARD_FEE_RATE) : 0;
    return {
      subtotal,
      fee,
      total: subtotal + fee
    };
  }

  function updateFeeBreakdown() {
    const totals = calculateTotals(amountInput ? amountInput.value : 0);
    if (subtotalOutput) subtotalOutput.textContent = formatMoney(totals.subtotal);
    if (feeOutput) feeOutput.textContent = formatMoney(totals.fee);
    if (totalOutput) totalOutput.textContent = formatMoney(totals.total);
  }

  if (amountInput) {
    amountInput.addEventListener("input", updateFeeBreakdown);
    updateFeeBreakdown();
  }

  if (!stripeKey || !paymentEndpoint || !window.Stripe) {
    showStatus("Stripe is not connected yet. Add the Stripe publishable key and backend endpoint in Shopify theme settings.", "error");
    if (payButton) payButton.disabled = true;
    return;
  }

  const stripe = window.Stripe(stripeKey);
  const elements = stripe.elements();
  const card = elements.create("card", {
    hidePostalCode: false,
    style: {
      base: {
        color: "#1b1f1a",
        fontFamily: "Inter, system-ui, sans-serif",
        fontSize: "16px",
        "::placeholder": {
          color: "#7a8376"
        }
      },
      invalid: {
        color: "#9f2a16"
      }
    }
  });

  card.mount(cardMount);
  card.on("change", function (event) {
    if (event.error) showStatus(event.error.message, "error");
    else status.hidden = true;
  });

  form.addEventListener("submit", async function (event) {
    event.preventDefault();
    status.hidden = true;
    payButton.disabled = true;
    payButton.textContent = "Processing...";

    const formData = new FormData(form);
    const totals = calculateTotals(formData.get("amount"));
    const amount = totals.total;

    if (!totals.subtotal) {
      showStatus("Enter a valid invoice amount before paying.", "error");
      payButton.disabled = false;
      payButton.textContent = "Pay invoice";
      return;
    }

    try {
      const response = await fetch(paymentEndpoint, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify({
          amount,
          currency: "usd",
          invoiceNumber: formData.get("invoiceNumber"),
          customerName: formData.get("customerName"),
          customerEmail: formData.get("customerEmail"),
          serviceNote: [
            formData.get("serviceNote"),
            "Invoice amount: " + formatMoney(totals.subtotal),
            "Card processing fee (3%): " + formatMoney(totals.fee),
            "Total charged today: " + formatMoney(totals.total)
          ].filter(Boolean).join("\n")
        })
      });

      const paymentIntent = await response.json();
      if (!response.ok || !paymentIntent.clientSecret) {
        throw new Error(paymentIntent.error || "The payment server did not return a Stripe client secret.");
      }

      const result = await stripe.confirmCardPayment(paymentIntent.clientSecret, {
        payment_method: {
          card,
          billing_details: {
            name: formData.get("customerName"),
            email: formData.get("customerEmail")
          }
        }
      });

      if (result.error) throw new Error(result.error.message);

      if (result.paymentIntent && result.paymentIntent.status === "succeeded") {
        card.clear();
        showSuccess();
      } else {
        showSuccess();
      }
    } catch (error) {
      showStatus(error.message || "Payment failed. Please try again or contact Greener Side.", "error");
    } finally {
      payButton.disabled = false;
      payButton.textContent = "Pay invoice";
    }
  });
})();
